<template>
  <div class="rank-item">
    <div class="rank-item-header">
      <div class="rank-item-id">{{ objCard.number }}</div>
      <ItemIcon
        v-if="objCard.type"
        :type="objCard.type"
        size="sm"
        :filled="false"
      />
    </div>
    <div class="rank-item-body">
      <div class="rank-desc">
        <router-link v-if="hasLink" :to="parsedUrl" class="title-card">{{ objCard.label || objCard.word }}</router-link>
        <span v-else class="title-card">{{ objCard.label || objCard.word }}</span>
        <div class="views-card">{{ objCard.count }}</div>
      </div>
      <div class="line-progress">
        <div v-if="percentage" ref="lineVal" class="line-value" />
      </div>
    </div>
  </div>
</template>
  
<script>
import ItemIcon from '../ItemIcon.vue'

export default {
  components: { ItemIcon },
  props: {
    objCard: {
      type: Object,
    },
    maxVal: {
      type: Number,
    },
    hasLink: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      percentage: null,
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
    parsedUrl() {
      let url = '#'
      if(this.objCard.id) {
        let source = this.$getTypesOfContent.data.find(el => el.type === this.objCard.type)?.label[this.currentLang] || null
        url = '/' + source + '/' + this.objCard.id
      } if(this.objCard.word) {
        url = '/search/' + this.objCard.word
      }
      return url
    }
  },
  watch: {
    percentage() {
        this.$refs.lineVal.style.width = this.percentage + '%'
    },
  },
  created() {
    if (this.objCard.count && this.maxVal) {
      let per = (this.objCard.count * 100) / this.maxVal
      this.percentage = per
    }
  },
  updated() {
    if (this.objCard.count && this.maxVal) {
      let per = (this.objCard.count * 100) / this.maxVal
      this.percentage = per
    }
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.rank-item
  display: flex
  align-items: flex-start
  overflow: hidden
  gap: vw(10px)

  &:not(:last-child)
    margin-bottom: vw(20px)

.rank-item-header
  display: flex
  align-items: center

  .rank-item-id
    m-font-size(14, 18)
    min-width: vw(30px)
    color: $grey-dark
    font-weight: 600

.rank-item-body
  flex: 1 1 0%
  overflow: hidden

.rank-desc
  display: flex
  justify-content: space-between
  margin-bottom: vw(10px)
  gap: vw(20px)

  .title-card
    m-font-size(14, 18)
    color: $grey
    word-break: break-word
    font-weight: 600
    
  a.title-card
    cursor: pointer
    &:hover
      text-decoration: underline

  .views-card
    m-font-size(14, 18)
    color: $grey
    font-weight: 400

.line-progress
  overflow: hidden
  height: 3px
  border-radius: 3px
  background-color: $light-grey

  .line-value
    height: 3px
    border-radius: 3px
    background-color: $corporate_color
</style>
